document.addEventListener("DOMContentLoaded", function() {


    // begin collection pagination icon adding
    var col_timer;
    col_timer = setInterval(function() {
        
    });
});